import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  getHasCollegeOnly,
  getHasMixedCollegeTypes,
  getProductTypes,
} from '../../../redux/modules/productTypes/productType.selectors';
import './CollegeBrandingContainer.scss';

const CollegeBrandingContainer = ({
  children,
  userProductTypes,
  getHasCollegeOnly,
}) => {
  const { hasAK529, hasMD529, hasNAT529 } = userProductTypes;

  const typeClassname =
    hasNAT529 && !(hasMD529 || hasAK529)
      ? 'nat-529'
      : hasMD529 && !(hasNAT529 || hasAK529)
      ? 'md-529'
      : hasAK529 && !(hasMD529 || hasNAT529)
      ? 'ak-529'
      : '';
  return (
    <div
      className={
        getHasCollegeOnly ? `college-page-container ${typeClassname}` : ''
      }
    >
      {children}
    </div>
  );
};

CollegeBrandingContainer.propTypes = {
  children: PropTypes.node.isRequired,
  hasMixedCollegeTypes: PropTypes.bool,
  userProductTypes: PropTypes.objectOf(PropTypes.bool),
};

const mapStateToProps = (state) => ({
  hasMixedCollegeTypes: getHasMixedCollegeTypes(state),
  userProductTypes: getProductTypes(state),
  getHasCollegeOnly: getHasCollegeOnly(state),
});

export default compose(connect(mapStateToProps))(CollegeBrandingContainer);
